.visibilityButton {
  position: absolute;
  right: 8px;
  top: 50%;
  height: 24px;
  width: 24px;
  padding: 0;
  border: none;
  outline: none;
  cursor: pointer;
  transform: translateY(-50%); // To vertically center the image
  background-color: var(--gray-04);
}

.visibleIcon {
  height: 24px;
  width: 24px;
  fill: var(--gray-00);
}

.errorIcon {
  fill: var(--red);
}

.input img {
  display: none;
}
